import { axios } from "../../config/axios"

export const loyaltyByLocationsAPI = {
  GETLoyaltyByLocations(params) {
    return axios.get(`/api/v3/merchant_locations`, params)
                .then(resp => resp.data)
                .catch(error => error)
  }
}